import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Comments/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/TextCodec/index.tsx");
